// import * as utils from '@/utils/utils';

import services from '../services/account.js'
import { message } from 'antd'

const { getUserInfo, login, logout, getPermissionList } = services

const namespace = 'account'

export default {
  namespace,
  state: {
    isLogin: false,
    userInfo: {
      // 用户信息
      userName: '',
    },
    permissionList: [], // 权限列表
    orgType: 0,
  },

  reducers: {
    updateState(state, { payload }) {
      return {
        ...state,
        ...payload,
      }
    },
  },

  effects: {
    // 更新数据
    *changeLogin({ payload, callback }, { put }) {
      yield put({
        type: 'updateState',
        payload: { ...payload },
      })
    },

    // 获取用户信息
    *getUserInfo({ payload, callback }, { call, put }) {
      const res = yield call(getUserInfo, { ...payload })
      if (res.success) {
        yield put({
          type: 'updateState',
          payload: { userInfo: res.data },
        })
      }
    },

    // 登录
    *login({ payload, callback }, { call }) {
      const res = yield call(login, { ...payload })
      if (res.success) {
        message.success('登录成功')
        window.location.href = '/#/overview/cockpit'
      } else {
        message.error(res.globalError)
      }
    },

    // 退出登录
    *logout({ payload, callback }, { call }) {
      const res = yield call(logout)
      if (res.success) {
        message.success('退出登录')
        window.location.href = '/#/account/login'
      } else {
        message.error(res.globalError)
      }
    },

    // 获取用户权限
    *getPermissionList({ payload, callback }, { call, put }) {
      const res = yield call(getPermissionList, { ...payload })
      if (res.success) {
        yield put({
          type: 'updateState',
          payload: { permissionList: res.data },
        })
      }
    },
  },
  // 订阅事件
  subscriptions: {},
}
